import { API_METHOD_PREFIX, WEBSOCKET_ENDPOINT } from 'config/config';

const endpoints = {
    accounts: {
        endpoint:         `${API_METHOD_PREFIX}v2/spog/account/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/spog/account/:id/`,
        aws:              {
            endpoint:         `${API_METHOD_PREFIX}v2/aws/account/`,
            instanceEndpoint: `${API_METHOD_PREFIX}v2/aws/account/:id/`
        },
        azure: {
            endpoint:         `${API_METHOD_PREFIX}v2/azure/subscription/`,
            instanceEndpoint: `${API_METHOD_PREFIX}v2/azure/subscription/:id/`
        },
        vcloud: {
            endpoint:         `${API_METHOD_PREFIX}v2/vcloud/account/`,
            instanceEndpoint: `${API_METHOD_PREFIX}v2/vcloud/account/:id/`
        },
        google: {
            endpoint:         `${API_METHOD_PREFIX}v2/google/account/`,
            instanceEndpoint: `${API_METHOD_PREFIX}v2/google/account/:id/`
        },
        oracle: {
            endpoint:         `${API_METHOD_PREFIX}v2/oracle/account/`,
            instanceEndpoint: `${API_METHOD_PREFIX}v2/oracle/account/:id/`
        },
        alicloud: {
            endpoint:         `${API_METHOD_PREFIX}v2/alicloud/account/`,
            instanceEndpoint: `${API_METHOD_PREFIX}v2/alicloud/account/:id/`
        }
    },
    awsProducts: {
        endpoint:         `${API_METHOD_PREFIX}v2/spog/constant/aws/product-name/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/spog/constant/aws/product-name/:id/`
    },
    awsRegions: {
        endpoint:         `${API_METHOD_PREFIX}v2/spog/constant/aws/region/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/spog/constant/aws/region/:id/`
    },
    awsSupport: {
        endpoint:         `${API_METHOD_PREFIX}v2/support/aws/ticket/:account/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/support/aws/ticket/:accountId/:ticketId/`,
        close:            `${API_METHOD_PREFIX}v2/support/aws/ticket/:account/:id/close/`,
        attachments:      {
            endpoint:         `${API_METHOD_PREFIX}v2/support/aws/attachment/:account/`,
            instanceEndpoint: `${API_METHOD_PREFIX}v2/support/aws/attachment/:account/:id/`
        },
        comments: {
            endpoint: `${API_METHOD_PREFIX}v2/support/aws/ticket/:account/:id/comment/`
        },
        billing: {
            endpoint: `${API_METHOD_PREFIX}v2/support/aws/ticket/billing/`
        },
        technical: {
            endpoint: `${API_METHOD_PREFIX}v2/support/aws/ticket/technical/`
        }
    },
    azrProducts: {
        endpoint:         `${API_METHOD_PREFIX}v2/spog/constant/azure/product-name/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/spog/constant/azure/product-name/:id/`
    },
    azrRegions: {
        endpoint:         `${API_METHOD_PREFIX}v2/spog/constant/azure/region/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/spog/constant/azure/region/:id/`
    },
    azureRefreshToken: {
        endpoint: `${API_METHOD_PREFIX}v2/azure/refresh-token/`
    },
    billingAlerts: {
        endpoint:             `${API_METHOD_PREFIX}v2/billing-alert/alert/`,
        instanceEndpoint:     `${API_METHOD_PREFIX}v2/billing-alert/alert/:id/`,
        endpointAlertsStates: `${API_METHOD_PREFIX}v2/billing-alert/state/`,
        endpointAlertsTypes:  `${API_METHOD_PREFIX}v2/billing-alert/entity-type/`
    },
    backupsDaily: {
        endpoint: `${API_METHOD_PREFIX}v2/reporting-backups/backup-host/daily-aggregated/`
    },
    backupsHosts: {
        endpoint:         `${API_METHOD_PREFIX}v2/reporting-backups/host/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/reporting-backups/host/:id/`
    },
    backupsAssociatedMachines: {
        endpoint: `${API_METHOD_PREFIX}v2/reporting-backups/associated-machines/`
    },
    categoriesAwsSupport: {
        endpoint: `${API_METHOD_PREFIX}v2/support/aws/category/:account/`
    },
    consolidateLastRun: {
        endpoint: `${API_METHOD_PREFIX}v2/reporting/consolidate-last-run/`
    },
    costcenters: {
        endpoint: `${API_METHOD_PREFIX}v2/reporting/costcenters/`
    },
    cloudBilling: {
        accountsEndpoint: `${API_METHOD_PREFIX}v2/reporting/cloud-billing/account/`,
        projectsEndpoint: `${API_METHOD_PREFIX}v2/reporting/cloud-billing/cost_center/`,
        vendorsEndpoint:  `${API_METHOD_PREFIX}v2/reporting/cloud-billing/vendor/`,
        regionsEndpoint:  `${API_METHOD_PREFIX}v2/reporting/cloud-billing/region/`,
        servicesEndpoint: `${API_METHOD_PREFIX}v2/reporting/cloud-billing/product/`,
        entitiesEndpoint: `${API_METHOD_PREFIX}v2/reporting/cloud-billing/:type/`,
        monthTotal:       `${API_METHOD_PREFIX}v2/reporting/month-total/`
    },
    cloudBillingSpending: {
        monthlyEndpoint: `${API_METHOD_PREFIX}v2/reporting/spending/`,
        dailyEndpoint:   `${API_METHOD_PREFIX}v2/reporting/spending/daily/`
    },
    impersonateUser: {
        endpoint:         `${API_METHOD_PREFIX}v2/cloudmasusers/impersonate-user/`,
        customerEndpoint: `${API_METHOD_PREFIX}v2/cloudmasusers/customer/`
    },
    issues: {
        extraActionsCreateComment: `${API_METHOD_PREFIX}v2/servicenow/incident/:id/`,
        endpoint:                  `${API_METHOD_PREFIX}v2/servicenow/incident/`,
        instanceEndpoint:          `${API_METHOD_PREFIX}v2/servicenow/incident/:id/`
    },
    entitiesId: {
        endpoing: `${API_METHOD_PREFIX}v2/spog/entity-id-list/`
    },
    requests: {
        extraActionsCreateComment: `${API_METHOD_PREFIX}v2/servicenow/request/:id/`,
        endpoint:                  `${API_METHOD_PREFIX}v2/servicenow/request/`,
        instanceEndpoint:          `${API_METHOD_PREFIX}v2/servicenow/request/:id/`
    },
    // DEPRECATED
    issueStatuses: {
        endpoint: `${API_METHOD_PREFIX}v2/servicenow/state/`
    },
    issuesByState: {
        endpoint: `${API_METHOD_PREFIX}v2/servicenow/split-incident/`
    },
    requestByState: {
        endpoint: `${API_METHOD_PREFIX}v2/servicenow/split-request/`
    },
    itcProducts: {
        endpoint:         `${API_METHOD_PREFIX}v2/spog/constant/itconic/product-name/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/spog/constant/itconic/product-name/:id/`
    },
    itcRegions: {
        endpoint:         `${API_METHOD_PREFIX}v2/spog/constant/itconic/region/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/spog/constant/itconic/region/:id/`
    },
    awsInstanceTypes: {
        endpoint:         `${API_METHOD_PREFIX}v2/spog/constant/aws/instance-type/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/spog/constant/aws/instance-type/:instance-type/`
    },
    operationLogs: {
        endpoint:         `${API_METHOD_PREFIX}v2/infrastructure-operations/task-status/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/infrastructure-operations/task-status/:id/`
    },
    reportBackups: {
        endpoint: `${API_METHOD_PREFIX}v2/reporting-backups/report/`
    },
    reportingBackupsHost: {
        endpoint: `${API_METHOD_PREFIX}v2/reporting-backups/backup-host/monthly/`
    },
    reportingBackupsMonthlyAggr: {
        endpoint: `${API_METHOD_PREFIX}v2/reporting-backups/backup-host/monthly-aggregated/`
    },
    reports: {
        endpoint:     `${API_METHOD_PREFIX}v2/reporting/billing/`,
        endpoint_v2:  `${API_METHOD_PREFIX}v2/reporting/detailed-billing/`,
        endpoint_old: `${API_METHOD_PREFIX}v2/reporting/fullreport/`
    },
    reservations: {
        endpoint: `${API_METHOD_PREFIX}v2/spog/aws/reservation/`
    },
    regions: {
        endpoint: `${API_METHOD_PREFIX}v2/spog/constant/region/`
    },
    resources: {
        endpoint:                                   `${API_METHOD_PREFIX}v2/inventory/instance/`,
        instanceEndpoint:                           `${API_METHOD_PREFIX}v2/inventory/instance/:id/`,
        extraActionsUpdateStartEndpoint:            `${API_METHOD_PREFIX}v2/operation/instance/:id/start/`,
        extraActionsUpdateStopEndpoint:             `${API_METHOD_PREFIX}v2/operation/instance/:id/stop/`,
        extraActionsCreateServiceDiscoveryEndpoint: `${API_METHOD_PREFIX}v2/operation/service-discovery/`,
        extraActionsInfrastructureOperations:       `${API_METHOD_PREFIX}v2/operation/instance-usage/:id/`
    },
    resourceTypes: {
        endpoint:         `${API_METHOD_PREFIX}v2/spog/constant/resource-type/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/spog/constant/resource-type/:resource-type/`
    },
    securityCredentials: {
        endpoint:         `${API_METHOD_PREFIX}v2/spog/security-credential/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/spog/security-credential/:id/`,
        aws:              {
            endpoint:         `${API_METHOD_PREFIX}v2/aws/credential/`,
            instanceEndpoint: `${API_METHOD_PREFIX}v2/aws/credential/:id/`
        },
        azure: {
            endpoint:         `${API_METHOD_PREFIX}v2/azure/credential/`,
            instanceEndpoint: `${API_METHOD_PREFIX}v2/azure/credential/:id/`
        },
        vcloud: {
            endpoint:         `${API_METHOD_PREFIX}v2/vcloud/credential/`,
            instanceEndpoint: `${API_METHOD_PREFIX}v2/vcloud/credential/:id/`
        },
        oracle: {
            endpoint:         `${API_METHOD_PREFIX}v2/oracle/credential/`,
            instanceEndpoint: `${API_METHOD_PREFIX}v2/oracle/credential/:id/`
        },
        google: {
            endpoint:         `${API_METHOD_PREFIX}v2/google/credential/`,
            instanceEndpoint: `${API_METHOD_PREFIX}v2/google/credential/:id/`
        },
        alicloud: {
            endpoint:         `${API_METHOD_PREFIX}v2/alicloud/credential/`,
            instanceEndpoint: `${API_METHOD_PREFIX}v2/alicloud/credential/:id/`
        }
    },
    services: {
        awsServices: {
            endpoint: `${API_METHOD_PREFIX}v2/spog/service/aws/`
        },
        azrServices: {
            endpoint: `${API_METHOD_PREFIX}v2/spog/service/azure-csp/`
        },
        googleServices: {
            endpoint: `${API_METHOD_PREFIX}v2/spog/service/google/`
        },
        vcloudServices: {
            endpoint: `${API_METHOD_PREFIX}v2/spog/service/vcloud/`
        },
        oracleServices: {
            endpoint: `${API_METHOD_PREFIX}v2/spog/service/oracle/`
        },
        alicloudServices: {
            endpoint: `${API_METHOD_PREFIX}v2/spog/service/alicloud/`
        },
        allServices: {
            endpoint: `${API_METHOD_PREFIX}v2/spog/service/` // Deprecated
        }
    },
    monitoring: {
        clientsID:        `${API_METHOD_PREFIX}v2/monitoring-report/ci/severity/`,
        objectsID:        `${API_METHOD_PREFIX}v2/monitoring-report/object-class/severity/`,
        daysBySeverity:   `${API_METHOD_PREFIX}v2/monitoring-report/event/severity-daily/`,
        events:           `${API_METHOD_PREFIX}v2/monitoring-report/event/severity/`,
        clientsIDClasses: `${API_METHOD_PREFIX}v2/monitoring-report/ci/ci_class/`,
        alarms:           `${API_METHOD_PREFIX}v2/monitoring-report/event/`,
        host:             `${API_METHOD_PREFIX}v2/monitoring-report/host/`,
        eventsTotal:      `${API_METHOD_PREFIX}v2/monitoring-report/event/total/`
    },
    serviceNow: {
        serviceOfferingEndpoint:          `${API_METHOD_PREFIX}v2/servicenow/service-offering/`,
        serviceNowUsersEndpoint:          `${API_METHOD_PREFIX}v2/servicenow/requester/`,
        companiesEndpoint:                `${API_METHOD_PREFIX}v2/servicenow/company/`,
        impactsEndpoint:                  `${API_METHOD_PREFIX}v2/servicenow/impact/`,
        urgencyEndpoint:                  `${API_METHOD_PREFIX}v2/servicenow/urgency/`,
        statesEndpoint:                   `${API_METHOD_PREFIX}v2/servicenow/state/`,
        callerIdEnpoint:                  `${API_METHOD_PREFIX}v2/servicenow/logged-user/`,
        writePermissionsIncidentEndpoint: `${API_METHOD_PREFIX}v2/servicenow/incident/:id/write-permission/`,
        writePermissionsRequestEndpoint:  `${API_METHOD_PREFIX}v2/servicenow/request/:id/write-permission/`,
        createCommentIssueEndpoint:       `${API_METHOD_PREFIX}v2/servicenow/incident/:id/comment/`,
        cancelIssueEndpoint:              `${API_METHOD_PREFIX}v2/servicenow/incident/:id/cancel/`,
        reactivateIssueEndpoint:          `${API_METHOD_PREFIX}v2/servicenow/incident/:id/reactivate/`,
        reopenIssueEndpoint:              `${API_METHOD_PREFIX}v2/servicenow/incident/:id/reopen/`,
        createCommentRequestEndpoint:     `${API_METHOD_PREFIX}v2/servicenow/request/:id/comment/`,
        cancelRequestEndpoint:            `${API_METHOD_PREFIX}v2/servicenow/request/:id/cancel/`,
        reactivateRequestEndpoint:        `${API_METHOD_PREFIX}v2/servicenow/request/:id/reactivate/`,
        reopenRequestEndpoint:            `${API_METHOD_PREFIX}v2/servicenow/request/:id/reopen/`,
        issuesEndpoint:                   `${API_METHOD_PREFIX}v2/servicenow/incident/`,
        requestEndpoint:                  `${API_METHOD_PREFIX}v2/servicenow/request/`,
        detailIssueEndpoint:              `${API_METHOD_PREFIX}v2/servicenow/incident/:id/`,
        detailRequestEndpoint:            `${API_METHOD_PREFIX}v2/servicenow/request/:id/`,
        watchListIssuesEndpoint:          `${API_METHOD_PREFIX}v2/servicenow/incident/:id/watch-list`,
        watchListRequestEndpoint:         `${API_METHOD_PREFIX}v2/servicenow/request/:id/watch-list`,
        catalogRequestEndpoint:           `${API_METHOD_PREFIX}v2/servicenow/catalog/`,
        catalogRequestDetailEndpoint:     `${API_METHOD_PREFIX}v2/servicenow/catalog/:id/`,
        catalogCategoryRequest:           `${API_METHOD_PREFIX}v2/servicenow/category/:id/`,
        catalogItemRequest:               `${API_METHOD_PREFIX}v2/servicenow/item/:id/`,
        uploadAttachments:                `${API_METHOD_PREFIX}v2/servicenow/attachment/`
        // getAttachmentEndpoint:            `api/v2/servicenow/attachment/:sysId/`
    },
    servicesAwsSupportBilling: {
        endpoint: `${API_METHOD_PREFIX}v2/support/aws/service/:account/billing/`
    },
    servicesAwsSupportTechnical: {
        endpoint: `${API_METHOD_PREFIX}v2/support/aws/service/:account/technical/`
    },
    servicesOffering: {
        endpoint: `${API_METHOD_PREFIX}v2/servicenow/serviceoffering/`
    },
    severities: {
        endpoint: `${API_METHOD_PREFIX}v2/support/aws/severity/:account/`
    },
    spendingByConcept: {
        endpoint: `${API_METHOD_PREFIX}v2/reporting/spending/`
    },
    spendingLastYear: {
        endpoint: `${API_METHOD_PREFIX}v2/reporting/spending-last12m/`
    },
    subscriptions: {
        endpoint: `${API_METHOD_PREFIX}v2/azure/subscription/`
    },
    tasksState: {
        endpoint:         `${API_METHOD_PREFIX}v2/spog/constant/task-state/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/spog/constant/task-state/:id/`
    },
    tasksTypes: {
        endpoint:         `${API_METHOD_PREFIX}v2/spog/constant/task-type/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/spog/constant/task-type/:id/`
    },
    totalSpending: {
        endpoint: `${API_METHOD_PREFIX}v2/reporting/total-spending/`
    },
    topByConcept: {
        endpoint: `${API_METHOD_PREFIX}v2/reporting/top-amount/`
    },
    vendors: {
        endpoint:         `${API_METHOD_PREFIX}v2/spog/constant/vendor/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/spog/constant/vendor/:vendor/`
    },
    vmStates: {
        endpoint:         `${API_METHOD_PREFIX}v2/spog/constant/vm-state/`,
        instanceEndpoint: `${API_METHOD_PREFIX}v2/spog/constant/vm-state/:vm-state/`
    },
    reportsP200: {
        endpoint:       `${API_METHOD_PREFIX}v2/general-services-customer/p200/`,
        downloadReport: `${API_METHOD_PREFIX}v2/general-services-customer/p200/:code_service_name/`
    },
    webSocketConexion: {
        endpoint: `${WEBSOCKET_ENDPOINT}websockets/ws/cloudglass/`
    },
    whoami: {
        endpoint: `${API_METHOD_PREFIX}v2/whoami`
    },
    storage: {
        storageAssigned:        `${API_METHOD_PREFIX}v2/storage-reports/assigned/`,
        storageOccupancy:       `${API_METHOD_PREFIX}v2/storage-reports/occupancy/`,
        storageDetail:          `${API_METHOD_PREFIX}v2/storage-reports/detail/`,
        storageVolume:          `${API_METHOD_PREFIX}v2/storage-reports/volume/`,
        storageObjectVolume:    `${API_METHOD_PREFIX}v2/storage-reports/object-storage-volume/`,
        storageObjectAssigned:  `${API_METHOD_PREFIX}v2/storage-reports/object-storage-assigned/`,
        storageObjectOccupancy: `${API_METHOD_PREFIX}v2/storage-reports/object-storage-occupancy/`

    },
    cmdb: {
        globalCake:        `${API_METHOD_PREFIX}v2/cmdb/global-chart/`,
        globalLast13M:     `${API_METHOD_PREFIX}v2/cmdb/global-last13m/`,
        backupCake:        `${API_METHOD_PREFIX}v2/cmdb/backup-chart/`,
        backupLast13m:     `${API_METHOD_PREFIX}v2/cmdb/backup-last13m/`,
        monitoringCake:    `${API_METHOD_PREFIX}v2/cmdb/monitoring-chart/`,
        monitoringLast13m: `${API_METHOD_PREFIX}v2/cmdb/monitoring-last13m/`,
        patchCake:         `${API_METHOD_PREFIX}v2/cmdb/patch-chart/`,
        patchLast13m:      `${API_METHOD_PREFIX}v2/cmdb/patch-last13m/`,
        serviceDetails:    `${API_METHOD_PREFIX}v2/cmdb/service-detail/`,
        deviceDetails:     `${API_METHOD_PREFIX}v2/cmdb/device-detail/`
    },
    iaas: {
        virtualMachines:           `${API_METHOD_PREFIX}v2/iaas/virtual-machines/`,
        globalInformation:         `${API_METHOD_PREFIX}v2/iaas/global-information/`,
        globalInfoVirtualMachines: `${API_METHOD_PREFIX}v2/iaas/virtual-machines/last12`,
        iaasVCenterResources:      `${API_METHOD_PREFIX}v2/iaas/virtual-machines-vcenter`
    },
    pageAnalytics: {
        endpoint: `${API_METHOD_PREFIX}v2/cloudmasusers/page-analytics/`
    },
    itsm: {
        openTickets:          `${API_METHOD_PREFIX}v2/itsm/open-tickets/`,
        summaryTickets:       `${API_METHOD_PREFIX}v2/itsm/summary-tickets/`,
        detailsTickets:       `${API_METHOD_PREFIX}v2/itsm/details-tickets`,
        summaryTicketsLast12: `${API_METHOD_PREFIX}v2/itsm/summary-tickets/last12`
    },
    customerProducts: {
        produtsDetails: `${API_METHOD_PREFIX}v2/customer-products/customer-products-detail`
    },

    checkPasswordExpiration: {
        endpoint: `v2/password/has-expired`
    }
};

export default endpoints;



// WEBPACK FOOTER //
// ./src/config/endpoints.js